import React from 'react';
import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';

import { Row } from 'reactstrap';

const IForm = ({ selectedRow }: any) => {
    const columsPop = 5;
    const columsPop1 = 1;
    const columsPop2 = 2;

    return (
        <>
            <div className="formContainer d-flex flex-column justify-content-evenly">
                <Row className="upRown pb-5">
                    <AvForm
                        className="custom-form mt-0"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                            gridAutoRows: 'minmax(10%, 60px)',
                            gridGap: '2%',
                            padding: '0',
                            textAlign: 'center',
                        }}
                    >
                        {selectedRow.createdAt && (
                            <div className="d-inline-block text-break text-wrap">
                                <label className="labelModal"> Date </label>
                                <label className="labelInfoModal">
                                    {' '}
                                    {selectedRow.createdAt}
                                </label>
                            </div>
                        )}
                        {selectedRow.clientId && (
                            <div className="d-inline-block text-break text-wrap">
                                <label className="labelModal"> Client Id </label>
                                <label className="labelInfoModal">
                                    {' '}
                                    {selectedRow.clientId}
                                </label>
                            </div>
                        )}
                        {selectedRow.operationType && (
                            <div className="d-inline-block text-break text-wrap">
                                <label className="labelModal"> Operation Type </label>
                                <label className="labelInfoModal"> {selectedRow.operationType}</label>
                            </div>
                        )}
                        {selectedRow.Number && (
                            <div className="d-inline-block text-break text-wrap">
                                <label className="labelModal"> Number </label>
                                <label className="labelInfoModal"> {selectedRow.Number}</label>
                            </div>
                        )}
                        {selectedRow.description && (
                            <div className="d-inline-block text-break text-wrap">
                                <label className="labelModal"> Descripcion </label>
                                <label className="labelInfoModal"> {selectedRow.description}</label>
                            </div>
                        )}
                    </AvForm>
                </Row>
                <Row className="DownRown">
                    <AvForm
                        className="custom-form mt-0"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${columsPop1}, 1fr)`,
                            gridAutoRows: 'minmax(10%, 80px)',
                            gridGap: '2%',
                            padding: '0',
                            textAlign: 'center',
                        }}
                    >
                        {selectedRow.description && (
                            <div className="d-inline-block text-break text-wrap">
                                <label className="labelModal"> Description </label>
                                <label className="labelInfoModal"> {selectedRow.description}</label>
                            </div>
                        )}

                    </AvForm>
                </Row>


            </div>
        </>
    );
};

IForm.propTypes = {
    selectedRow: PropTypes.shape({
        ClientId: PropTypes.string,
        Number: PropTypes.string,
        operationType: PropTypes.string,
        description: PropTypes.string,
        createdAt: PropTypes.string,
    }),
};

export default IForm;
